import { reportTypes } from '../utils/reports';

export const AVAILABILITY_PARAMETER_OPTION__DIMENSION = { name: 'dimension', display_name: 'Dimension' };
export const AVAILABILITY_PARAMETER_OPTION__SOURCE = { name: 'source', display_name: 'Source' };

export const availabilityParameterOptions = [
    AVAILABILITY_PARAMETER_OPTION__SOURCE,
    AVAILABILITY_PARAMETER_OPTION__DIMENSION,
];

export const BASE_DIMENSION_TYPE = 'dimensions';

export const DIMENSION_TYPES_BY_REPORT_TYPE_WHITELIST = {
    [reportTypes.mainReport]: ['metadataDimensions', 'attributionInsightsDimensions'],
    [reportTypes.pivot]: ['metadataDimensions', 'attributionInsightsDimensions'],
    [reportTypes.creativeExplore]: [
        'creativeMeasurementDimensions',
        'technicalSpecsDimensions',
        'metadataDimensions',
        'promotedContentDetailsDimensions',
        'organicInsightsDimensions',
        'attributionInsightsDimensions',
    ],
};

export const REPORTS_FIELDS_BLACKLIST = ['source'];

export const HARDCODED_FIELDS = {
    dimensions: [
        {
            type: 'dimension',
            name: 'creative_image_hash',
            display_name: 'Creative Preview',
            creative_visible: true,
            visible: false,
        },
    ],
};

export const AVAILABILITY_TYPES = {
    MAPPED: 'interpolated',
    CALCULATED: 'calculated',
    COMBINED: 'combined',
    NOT_PULLED: 'not_pulled',
};

export const FIELDS_AVAILABILITY_MIXPANEL_PREFIX = 'Fields Availability';

export const MAX_SOURCES_TO_DISPLAY_ON_TOOLTIP = 2;

export const FIELDS_AVAILABILITY_ENABLED_REPORT_TYPES = [
    reportTypes.skan,
    reportTypes.mainReport,
    reportTypes.pivot,
    reportTypes.creativeExplore,
];
